import React from 'react';
import classes from '../styles.module.scss';
import formClasses from '../../styles.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('ai-settings', classes);

interface DiarizationGroupProps {
  tokenSet: boolean;
  tokenValue: string;
  onTokenChange: (value: string) => void;
}

const DiarizationGroup = ({ tokenSet, tokenValue, onTokenChange }: DiarizationGroupProps) => {
  return (
    <div className={cn('group')}>
      <div className={cn('group-title')}>Диаризация</div>

      <div className={formClasses['form-group']}>
        <label>
          HF-токен{' '}
          <span className={cn('key-badge', { set: tokenSet })}>
            {tokenSet ? 'токен задан' : 'токен не задан'}
          </span>
        </label>
        <input
          type="password"
          value={tokenValue}
          onChange={(e) => onTokenChange(e.target.value)}
          placeholder="Оставьте пустым, чтобы не менять"
          autoComplete="new-password"
        />
      </div>

      <div className={cn('group-desc')}>
        Токен HuggingFace (Read) для модели pyannote. Получить: huggingface.co/settings/tokens,
        принять условия pyannote/speaker-diarization-3.1 и pyannote/segmentation-3.0.
      </div>
    </div>
  );
};

export default DiarizationGroup;
